export default __webpack_public_path__ + "static/media/490.da7e4d44.png";